// Libs
import { type FC, useState } from "react";

// Components
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useField } from "formik";
import moment from "moment";

export interface DatePickerComponentProps extends Omit<any, "onChange" | "value"> {
    name: string;
    disabled?: boolean;
    handleChange?: (event: any) => void;
    hasMinDate?: boolean;
    maxDate?: Date | undefined;
    minDate?: Date | undefined;
}

export const DatePickerComponent: FC<DatePickerComponentProps> = ({
    name,
    label,
    handleChange,
    disabled,
    hasMinDate = true,
    maxDate = null,
    minDate = null,
}) => {
    const [field, meta, helpers] = useField(name);
    const [open, setOpen] = useState(false);

    const isOnError = Boolean(meta.error && meta.touched);
    const isValidDate = dayjs(field.value).isValid();

    return (
        <DesktopDatePicker
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            open={open}
            name={name}
            format="DD/MM/YYYY"
            disabled={disabled}
            label={label}
            minDate={
                minDate === null ? (hasMinDate === true ? dayjs() : undefined) : dayjs(minDate)
            }
            maxDate={maxDate === null ? undefined : dayjs(maxDate)}
            onChange={(value) => {
                const formatNewValue = moment(dayjs(value).toISOString());
                helpers.setValue(formatNewValue);
                if (handleChange) {
                    handleChange(formatNewValue);
                }
            }}
            slotProps={{
                textField: {
                    error: isOnError,
                    onClick: (event) => {
                        event.preventDefault(); // Empêche les actions par défaut
                        setOpen(true); // Force l'ouverture du DatePicker
                    },
                    helperText: isOnError ? meta.error : "",
                },
            }}
            value={isValidDate ? dayjs(field.value) : undefined}
        />
    );
};
